<template>
  <v-select
    v-model="val"
    :options="enums('Language')"
    :clearable="clearable"
    dir="rtl"
    label="text"
    :reduce="x => x.value"
    :selectable="x => unselectable.includes(x.value) === false || x.value === val"
  />
</template>

<script>

export default {
  name: 'Language',
  props: {
    value: {
      type: Number,
      default: null,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    unselectable: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      val: this.value,
    }
  },
  watch: {
    value(v) {
      this.val = v
    },
    val(v) {
      this.$emit('input', v)
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
